import { PlusOutlined } from "@ant-design/icons"
import {
  Card,
  Flex,
  Skeleton,
  Typography,
  Upload,
  type UploadProps
} from "antd"
import React, { memo } from "react"

interface ProjectAllFilesUploadCardProps {
  uploadProps: UploadProps
  maxFileSize: number
  allowedExtensions: string[]
  hasUploadingFiles: boolean
}

export const ProjectAllFilesUploadCard = memo(
  ({
    uploadProps,
    allowedExtensions,
    maxFileSize,
    hasUploadingFiles
  }: ProjectAllFilesUploadCardProps) => {
    return (
      <Upload {...uploadProps} rootClassName="h-full [&_.ant-upload]:size-full">
        <Card
          hoverable
          className="h-full border-dashed cursor-pointer"
          styles={{ body: { padding: 8, height: "100%" } }}
        >
          <Flex
            vertical
            align="center"
            justify="center"
            gap={4}
            className="h-full text-gray-400"
          >
            {hasUploadingFiles ? (
              <>
                <Skeleton.Avatar active size="large" />
                <Typography.Text type="secondary" className="text-xs">
                  Uploading...
                </Typography.Text>
              </>
            ) : (
              <>
                <PlusOutlined className="text-3xl" />
                <Typography.Text type="secondary">Upload Files</Typography.Text>
                <Typography.Text
                  type="secondary"
                  className="text-xs text-center"
                >
                  {allowedExtensions.join(", ")?.toUpperCase()}
                  <br />
                  up to {maxFileSize}MB
                </Typography.Text>
              </>
            )}
          </Flex>
        </Card>
      </Upload>
    )
  }
)

ProjectAllFilesUploadCard.displayName = "ProjectAllFilesUploadCard"
